module.exports = __webpack_public_path__ + "img/workFlowYcx.55b3feac.png";